module.exports = __webpack_public_path__ + "static/img/image_solutions_key_dolphin.f3e89cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_key_dolphin.png
// module id = VQxh
// module chunks = 10